import type { MerchandisingHeaderContentBlock } from '@library/api-menu-experience'
import type { CollectionMerchandising } from '@library/menu-service'

import { toGradientInfoHeaderContentBlock, toWaveLinkHeaderContentBlock } from './adapters'

const isLegacyMerchandisingHeader = (
  merchandising: CollectionMerchandising,
): merchandising is Extract<
  CollectionMerchandising,
  { type: 'gradient-info-header' | 'wave-link-header' }
> => merchandising.type === 'gradient-info-header' || merchandising.type === 'wave-link-header'

export const getLegacyMerchandisingHeaderContentBlock = (
  merchandising?: CollectionMerchandising[] | null,
): Extract<
  MerchandisingHeaderContentBlock,
  { type: 'gradient-info-header' | 'wave-link-header' }
> | null => {
  const legacyHeader = merchandising?.find(isLegacyMerchandisingHeader)

  if (!legacyHeader) {
    return null
  }

  if (legacyHeader.type === 'gradient-info-header') {
    return toGradientInfoHeaderContentBlock(legacyHeader)
  }

  return toWaveLinkHeaderContentBlock(legacyHeader)
}
